import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { TimeIcon } from '@winelidays/wld-tsx-2/images';
import { formatDuration } from '@winelidays/wld-tsx-2/utils';
import PracticalLine from '../PracticalLine';
const DurationContent = t0 => {
    const $ = _c(3);
    const { informations } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== informations || $[1] !== translate) {
        t1 = "duration" in informations ? <PracticalLine icon={<TimeIcon />} content={formatDuration({
                duration: informations.duration,
                translate
            })}/> : null;
        $[0] = informations;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    return t1;
};
export default DurationContent;
